import { render, staticRenderFns } from "./SbaFormFeatures.vue?vue&type=template&id=76c70943&"
import script from "./SbaFormFeatures.vue?vue&type=script&lang=ts&"
export * from "./SbaFormFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports